module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/osbornebulls.7518daf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/osbornebulls.jpg
// module id = nB8A
// module chunks = 0